const ActionTypes = require('../constants/ActionTypes');

const StageActions = {

    setPlaying(playing) {
        return {
            type: ActionTypes.SET_PLAYING,
            payload: {
                playing,
            },
        };
    },

    setScene(sceneKey) {
        return {
            type: ActionTypes.SET_SCENE,
            payload: {
                sceneKey,
            },
        };
    },

    setFrameDone(sceneKey, index) {
        return {
            type: ActionTypes.SET_FRAME_DONE,
            payload: {
                sceneKey,
                index,
            },
        };
    },

    setLanguage(language) {
        return {
            type: ActionTypes.SET_LANGUAGE,
            payload: {
                language,
            },
        };
    },

    setMessageBoxPlaying(playing) {
        return {
            type: ActionTypes.SET_MESSAGE_BOX_PLAYING,
            payload: {
                playing,
            },
        };
    },

    setHeaderAppearance(headerAppearance) {
        return {
            type: ActionTypes.SET_HEADER_APPEARANCE,
            payload: {
                headerAppearance,
            },
        };
    },

    setMenuOpen(menuOpen) {
        return {
            type: ActionTypes.SET_MENU_OPEN,
            payload: {
                menuOpen,
            },
        };
    },

    setSoundBarOpen(soundBarOpen) {
        return {
            type: ActionTypes.SET_SOUND_BAR_OPEN,
            payload: {
                soundBarOpen,
            },
        };
    },

    setMasterVolume(masterVolume) {
        return {
            type: ActionTypes.SET_MASTER_VOLUME,
            payload: {
                masterVolume,
            },
        };
    },

    setPage(pageKey) {
        return {
            type: ActionTypes.SET_PAGE,
            payload: {
                pageKey,
            },
        };
    },

    completeScene(sceneKey) {
        return {
            type: ActionTypes.COMPLETE_SCENE,
            payload: {
                sceneKey,
            },
        };
    },

    completeInteraction(key) {
        return {
            type: ActionTypes.COMPLETE_INTERACTION,
            payload: key,
        };
    },

    uncompleteInteraction(key) {
        return {
            type: ActionTypes.UNCOMPLETE_INTERACTION,
            payload: key,
        };
    },

    updateSkipIntro(skipIntro) {
        return {
            type: ActionTypes.UPDATE_SKIP_INTRO,
            payload: {
                skipIntro,
            },
        };
    },

    updateLearnMore(opened, key, content) {
        return {
            type: ActionTypes.LEARN_MORE_CHANGE,
            payload: {
                opened,
                key,
                content: typeof content !== 'undefined' ? content : null,
            },
        };
    },

};

module.exports = StageActions;



// WEBPACK FOOTER //
// ./js/actions/StageActions.js